<template>
  <div class="reason">
    <h1 :key="props.reason.rowId">{{ props.reason?.reason }}</h1>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps(['reason'])
</script>

<style lang="scss" scoped>
.reason {
  height: 60px;
  display: flex;
  justify-content: center;

  h1 {
    font-family: 'Cervo';
    text-transform: uppercase;
    font-size: 2rem;
    color: rgb(var(--q-red));
    text-align: center;

    @media screen and (max-width: 600px) {
      font-size: 1.5rem;
    }
  }
}
</style>
